import React, { useContext } from "react";
import { ClassesContext } from "../../../Context";
import { Link } from "react-router-dom";
import { usePrimaryColor } from "./PrimaryColorContext";


/**
 * HtClass - Reusable component to display a class name as a link or plain text.
 * Uses the flat premium design language with dynamic primary color.
 *
 * @param {object} props Component props
 * @param {string} props.htClass The class ID (used when rendering as a link)
 * @param {string} props.id Alternative class ID (takes priority over htClass)
 * @param {boolean} [props.link=true] Whether to render as a link or plain text
 * @param {object} [props.style] Additional inline styles
 * @author Forge
 * @date 2026-04-08
 * @version 2.0
 */
export default function HtClass(props) {
  const { htClass, id, link = true, style } = props;
  const { findClass } = useContext(ClassesContext);
  const { primaryColor } = usePrimaryColor();
  const cl = findClass(id ? id : htClass);

  if (!cl) return <span className="text-xs text-[#94a3b8] italic">No class</span>;

  if (!link) {
    return (
      <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-${primaryColor}-50 text-${primaryColor}-800`}>
        {cl.name}
      </span>
    );
  }

  return (
    <Link
      to={`/class/${htClass}`}
      style={style}
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-${primaryColor}-50 text-${primaryColor}-800 hover:bg-${primaryColor}-100 transition-colors duration-150 no-underline`}
    >
      {cl.name}
    </Link>
  );
}
